import { ReadMappingData } from '@/endpoints/schemas'

export interface OpenedReadMappingData {
	dirty: boolean
	form: ReadMappingDataForm
	original: ReadMappingDataForm
	parsedEditMode: boolean
	stereotypeId: number
	tab: ReadMappingTab
}

export type ReadMappingDataForm = Partial<ReadMappingData>

export enum ReadMappingTab {
	Columns = 'Columns',
	Dependencies = 'Dependencies',
	Deployments = 'Deployments',
	Others = 'Others',
	Overview = 'Overview',
	Preview = 'Preview',
	Sources = 'Sources',
	Validation = 'Validation',
	Versions = 'Versions',
}
